var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransformadores = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #171954;\n        stroke-miterlimit: 10;\n        stroke-width: 2.49px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.38,
    y: 26.83,
    width: 12.15,
    height: 26.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.53,
    y: 26.83,
    width: 12.15,
    height: 26.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.18,
    y: 26.83,
    width: 12.15,
    height: 26.71
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.82,
    y: 26.83,
    width: 12.15,
    height: 26.71
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.47,
    y: 26.83,
    width: 12.15,
    height: 26.71
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.32,
    y: 20.93,
    width: 49.23,
    height: 5.31
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.64,
    y: 54.14,
    width: 49.23,
    height: 5.31
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.06,
    y: 15.03,
    width: 4.87,
    height: 5.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.26,
    y: 15.03,
    width: 4.87,
    height: 5.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.46,
    y: 15.03,
    width: 4.87,
    height: 5.9
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransformadores);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TRANSFORMADORES.4a834b404a0f41e613d0989be48295d9.svg";